import { gql } from 'graphql-tag';

// Mutation to start the export job
export const EXPORT_REDEEMED_CREDITS = gql`
  mutation GetAccountRedeemedCreditsReport($input: GetAccountCreditsInput!) {
    getAccountRedeemedCreditsReport(input: $input) {
      jobId
      message
      __typename
    }
  }
`;

// Subscription to track export status (same as open credits)
export const CREDIT_EXPORT_STATUS = gql`
  subscription CreditExportStatus($jobId: String!) {
    creditExportStatus(jobId: $jobId) {
      jobId
      status
      progress
      downloadUrl
      filename
      recordCount
      error
      createdAt
      completedAt
      __typename
    }
  }
`;

// Query to get download URL (if not provided in subscription)
export const GET_CREDIT_EXPORT_DOWNLOAD_URL = gql`
  query GetCreditExportDownloadUrl($jobId: String!) {
    getCreditExportDownloadUrl(jobId: $jobId)
  }
`;
